import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form';
import OtpInput from 'react-otp-input';
import { fetcher } from 'api/client';
import { clientContractAction } from 'api/actions/contracts';
import { useMutation, useQueryClient } from 'react-query';
import { convertToBase64 } from 'utils';
import { useSign, CONTROL_MODAL, ONETIME_PASSWORD_MODAL } from 'context/signview';
import clsx from 'clsx';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Form, Media, ButtonGroup, Spinner } from 'reactstrap';
import { toast } from 'components/Shared/Toast';
import useInterval from 'hooks/useInterval';


export default function Veridoc() {
    const { t } = useTranslation();
    const [{ modal, contractId, jwt, fingerprint, contract }, dispatch] = useSign();
    const [otp, setOtp] = useState('');
    const [sendCodeTimer, setSendCodeTimer] = useState(0);
    const [delay, setDelay] = useState(Number.MAX_SAFE_INTEGER);

    const queryClient = useQueryClient();
    const onError = (error) => {
        toast.error(t(`errors.${error.message}`,  t('errors.GeneralError')))
    }

    const { mutate: mutateSendOneTimePassword, isLoading, error } =
        useMutation((payload) =>
            fetcher(clientContractAction(contractId, 'sendOneTimePassword', payload), jwt), {
            onSuccess: () => {
                toast.success(t(`onetimePassword.codeSentSuccess`, { context : contract.notificationType }))
                setDelay(1000)
                setSendCodeTimer(30)
            },
            onError
        });

    const { mutate: mutateRespondOneTimePasswordChallenge } =
        useMutation((payload) =>
            fetcher(clientContractAction(contractId, 'respondOneTimePasswordChallenge', payload), jwt), {
            onSuccess: () => {
                toast.success(t('onetimePassword.verifySuccess'))
                queryClient.invalidateQueries('client-contract')
                handleClose()
            },
            onError
        });

    const handleClose = () => {
        dispatch({ type: CONTROL_MODAL, close: ONETIME_PASSWORD_MODAL })
    }

    const handleSubmit = async (values) => {
        mutateRespondOneTimePasswordChallenge({ code: otp, fingerprintId: fingerprint.visitorId })
    }

    const handleSendCode = async () => {
        mutateSendOneTimePassword()
    }

    const handleChange = async (value) => {
       setOtp(value)
    }

   useInterval(() => {
       if (sendCodeTimer >= 0) {
        setSendCodeTimer(sendCodeTimer - 1)
        if (sendCodeTimer - 1 === 0) setDelay(Number.MAX_SAFE_INTEGER)
       }
   }, delay)

   console.log({delay})

    return (
        <Modal
            isOpen={modal.includes(ONETIME_PASSWORD_MODAL)}
            centered
        >
                <ModalHeader toggle={handleClose}>
                    {t('onetimePassword.title')}
                </ModalHeader>
                <ModalBody>
                    <Media>
                        <Media body className="text-center d-flex align-items-center flex-column mb-3">
                            <h5 className="font-weight-bold mb-3">{t('onetimePassword.message')}</h5>
                            <OtpInput
                                value={otp}
                                onChange={handleChange}
                                numInputs={6}
                                isInputNum
                                inputStyle={{
                                    width: '3rem',
                                    height: '3rem',
                                    margin: '0 1rem',
                                    padding: '1px 2px',
                                    fontSize: '2rem',
                                    borderRadius: '4px',
                                    border: '1px solid rgba(0, 0, 0, 0.3)'
                                }}
                                separator={<span>-</span>}
                            />
                            <Button className="mt-4" size="sm" onClick={handleSendCode} disabled={sendCodeTimer > 0}>{t('onetimePassword.sendCode')}</Button>
                            { sendCodeTimer > 0 && <small className="text-muted mt-1">{t('onetimePassword.countdown', { count: sendCodeTimer, sendCodeTimer })}</small>}
                        </Media>
                    </Media>
                    <span className="text-danger">{error?.message}</span>
                </ModalBody>
                <ModalFooter>
                    <ButtonGroup className="d-flex flex-grow-1">
                        <Button color="primary" className="d-flex justify-content-center" onClick={handleSubmit} disabled={otp.length < 6}>
                            <Spinner color="secondary" className="mr-2" size="sm" hidden={!isLoading} />{t('sign.sign.delegate_send')}
                        </Button>
                    </ButtonGroup>
                </ModalFooter>
        </Modal>
    )
}
